export let ParameterType = /*#__PURE__*/function (ParameterType) {
  ParameterType["UNKNOWN"] = "UNKNOWN";
  ParameterType["STRING_TYPE"] = "STRING_TYPE";
  ParameterType["INTEGER_TYPE"] = "INTEGER_TYPE";
  ParameterType["DECIMAL_TYPE"] = "DECIMAL_TYPE";
  ParameterType["DATE_TYPE"] = "DATE_TYPE";
  ParameterType["DEFAULT_VALUES_TYPE"] = "DEFAULT_VALUES_TYPE";
  ParameterType["DEFAULT_VALUES_MULTISELECT_TYPE"] = "DEFAULT_VALUES_MULTISELECT_TYPE";
  ParameterType["MULTIFIELD_TYPE"] = "MULTIFIELD_TYPE";
  ParameterType["LOCATOR_TYPE"] = "LOCATOR_TYPE";
  ParameterType["DATETIME_TYPE"] = "DATETIME_TYPE";
  ParameterType["BOOLEAN_TYPE"] = "BOOLEAN_TYPE";
  return ParameterType;
}({});
export let ParameterState = /*#__PURE__*/function (ParameterState) {
  ParameterState["NO_VALIDATION"] = "NO_VALIDATION";
  ParameterState["VALID"] = "VALID";
  ParameterState["INVALID"] = "INVALID";
  return ParameterState;
}({});
export let ParameterVisualizationMode = /*#__PURE__*/function (ParameterVisualizationMode) {
  ParameterVisualizationMode["COMBO"] = "COMBO";
  ParameterVisualizationMode["BUTTONS"] = "BUTTONS";
  ParameterVisualizationMode["SLIDER"] = "SLIDER";
  ParameterVisualizationMode["CHECK"] = "CHECK";
  return ParameterVisualizationMode;
}({});